import type { FormField } from "@/components/website-builder/blocks/types"
import { ContactFormView } from "@/components/website-builder/ContactFormView"
import type { BlockComponentProps } from "./shared"

export function FormBlock({ content, org, resolved, sectionId }: BlockComponentProps) {
  const formFields = (content?.fields as FormField[] | undefined) ?? []
  const formHeading = (content?.heading as string) ?? "Get in touch"
  const formSubmitLabel = (content?.submit_label as string) ?? "Send message"
  const formSectionClass = resolved.hasOverrides
    ? `px-4 @sm:px-6 @md:px-8 ${resolved.paddingClass || "py-8"} ${resolved.cornerClass} ${resolved.alignClass}`.trim()
    : "px-4 py-8 @sm:px-6 @md:px-8"
  const primaryColor = "var(--nos-color-primary, #3b82f6)"
  return (
    <section className={formSectionClass} style={resolved.sectionStyle}>
      {org?.id ? (
        <ContactFormView
          orgId={org.id}
          sectionId={sectionId}
          fields={formFields}
          heading={formHeading}
          submitLabel={formSubmitLabel}
          primaryColor={primaryColor}
        />
      ) : (
        <p className="text-muted-foreground text-sm">Contact form (configure in website builder)</p>
      )}
    </section>
  )
}
